module.exports = __webpack_public_path__ + "bi.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/bi.svg
// module id = 450
// module chunks = 0